import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FeatureFlag} from 'react-launch-darkly';
import {DistributionMetricsDownloadButton} from 'js/distribution_metrics_download_button';

export default class AnalyticsHeaderContainer extends Component {
    static propTypes = {
        displayShareButton: PropTypes.bool.isRequired,
        brandName: PropTypes.string.isRequired,
        campaignName: PropTypes.string,
        campaignCount: PropTypes.number,
        handleShareCampaignShow: PropTypes.func,
        isAdmin: PropTypes.bool,
        isSalesUser: PropTypes.bool,
        showCampaignWrapUp: PropTypes.bool,
        isWrapUpBrandVisible: PropTypes.bool,
        isTiktok: PropTypes.bool,
        campaignCode: PropTypes.string,
        inviteLink: PropTypes.string
    };

    static defaultProps = {
        displayDatePicker: true,
        displayShareButton: true
    };

    displayShareButton = () => {
        const {displayShareButton, isSalesUser, handleShareCampaignShow} = this.props;

        if (displayShareButton && !isSalesUser) {
            return (
                <button className="btn btn-info" onClick={handleShareCampaignShow}>
                    Share this Campaign
                </button>
            );
        }
    };

    displayCampaignWrapUpButton = () => {
        const {showCampaignWrapUp, isWrapUpBrandVisible, isAdmin, campaignWrapUpUrl} = this.props;

        if (isAdmin) {
            return showCampaignWrapUp ? (
                <a href={campaignWrapUpUrl} className="btn btn-info btn-wrap-up">
                    View Your Wrap Up Report
                </a>
            ) : null;
        }
        return showCampaignWrapUp && isWrapUpBrandVisible ? (
            <a href={campaignWrapUpUrl} className="btn btn-info btn-wrap-up">
                View Your Wrap Up Report
            </a>
        ) : null;
    };

    displayMetricsCsvDownloadButton = (show = 'off') => {
        if (show === 'off') {
            return;
        }

        return (
            <DistributionMetricsDownloadButton
                dimensions={{campaign_ids: [window.sn.analyticsData.campaign_id]}}
                style={{marginLeft: '15px'}}
            >
                Download Metrics
            </DistributionMetricsDownloadButton>
        );
    };

    displayBrandOptions = () => {
        const shareButton = this.displayShareButton();
        const campaignWrapUpButton = this.displayCampaignWrapUpButton();

        return (
            <div className="btn-toolbar btn-toolbar--brand-options pull-right">
                {campaignWrapUpButton}
                {shareButton}
                <FeatureFlag
                    flagKey="campaign-data-impressions-metric"
                    renderFeatureCallback={this.displayMetricsCsvDownloadButton}
                />
            </div>
        );
    };

    displayBrandName = () => {
        const {brandName} = this.props;

        return brandName ? (
            <div>
                <h1 className="brand-name">{brandName}</h1>
            </div>
        ) : null;
    };

    displayCampaignName = () => {
        const {campaignName} = this.props;

        if (campaignName) {
            return (
                <div className="pull-left">
                    <h1 className="campaign-name">{campaignName}</h1>
                </div>
            );
        }
    };

    displayCampaignCount = () => {
        const {campaignCount} = this.props;

        if (campaignCount) {
            return (
                <div className="pull-left">
                    <h4>{`(All of your content across ${campaignCount} Social Native campaign${
                        campaignCount === 1 ? '' : 's'
                    })`}</h4>
                </div>
            );
        }
    };

    displayInsightsButton = (show = 'off') => {
        if (show === 'off') {
            return null;
        }

        return (
            <a
                className="snclient-tab-nav-item"
                href={`/insights?campaign_id=${window.sn.analyticsData.campaign_id}`}
            >
                Insights
            </a>
        );
    };

    displayPaidButton = (show) => {
        if (!show || show === 'off') {
            return null;
        }

        return (
            <a
                className="snclient-tab-nav-item"
                href={`/distributions?campaign_id=${window.sn.analyticsData.campaign_id}&distribution_type=facebook_paid`}
            >
                Paid
            </a>
        );
    }

    displayTiktokOptions = (isTiktok, inviteLink, campaignCode) => {
        if (!isTiktok) {
            return null;
        }

        return (
            <div>
                <div className="tiktok-options pull-right">
                    {inviteLink &&
                        <div className="tiktok-options-box">
                            <span className="tiktok-options-box-label">
                                Invite Link:
                            </span>
                            <a className="tiktok-options-box-link"
                                href={inviteLink}
                                target='_blank'
                                rel="noreferrer">
                                {inviteLink}
                            </a>
                        </div>
                    }
                    {campaignCode &&
                        <div className="tiktok-options-box">
                            <span className="tiktok-options-box-label">
                                Campaign Code:
                            </span>
                            {campaignCode}
                        </div>
                    }
                </div>
            </div>
        );

    }

    render() {
        const brandOptions = this.displayBrandOptions();
        const brandName = this.displayBrandName();
        const campaignName = this.displayCampaignName();
        const campaignCount = this.displayCampaignCount();

        const {isTikTok = false, campaignCode, inviteLink} = this.props;
        const tiktokOptions = this.displayTiktokOptions(isTikTok, inviteLink, campaignCode);

        return (
            <div className="analytics-header">
                {brandName}
                <div className="row">
                    <div className="col-md-6">
                        {campaignName}
                        {campaignCount}
                    </div>
                    <div className="col-md-6">{brandOptions}</div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <nav className="snclient-tab-nav">
                            <div className="snclient-tab-nav-item active">Organic</div>

                            <FeatureFlag
                                flagKey="fb-business-banner-enabled"
                                renderFeatureCallback={this.displayPaidButton}
                            />

                            <FeatureFlag
                                flagKey="campaign-data-insights-route"
                                renderFeatureCallback={this.displayInsightsButton}
                            />
                        </nav>
                    </div>
                    {isTikTok && <div className="col-md-6">{tiktokOptions}</div>}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/header/index.js